"use client";

import { Mic } from "lucide-react";
import { motion } from "framer-motion";

interface VoiceListeningIndicatorProps {
  color?: string;
  label?: string;
}

export default function VoiceListeningIndicator({
  color = "#C1A2FF",
  label = "Listening",
}: VoiceListeningIndicatorProps) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="relative flex items-center justify-center w-5 h-5">
        <span
          className="absolute inset-0 rounded-full opacity-40"
          style={{ background: color }}
        />
        <motion.span
          className="absolute inset-0 rounded-full"
          style={{ background: color }}
          animate={{ scale: [1, 1.8, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
        />
        <Mic className="w-3 h-3 relative z-10" style={{ color }} />
      </div>

      <span className="text-xs font-medium tracking-wide text-white/90">
        {label}
      </span>

      <div className="flex items-end gap-[3px] h-3.5">
        {[0, 1, 2, 3].map((i) => (
          <motion.span
            key={i}
            className="w-[3px] rounded-full"
            style={{ background: color }}
            animate={{
              height: [4, 14, 6, 16, 5],
            }}
            transition={{
              duration: 0.9,
              repeat: Infinity,
              repeatType: "reverse",
              delay: i * 0.12,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <span className="text-xs text-white/50 w-4">
        <motion.span
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
        >
          …
        </motion.span>
      </span>
    </div>
  );
}
